


































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'

@Component({
  components: { InvoicePersonTypeView, TextEllipsis, BaseButton }
})
export default class PreInvoice extends Vue {
  constructor() {
    super()
  }

  @Prop() billing_info !: BillingInfoResourceModel
  @Prop() downloadUrl!: string | URL

  showInvoice = false

  get invoiceIcon() {
    return this.showInvoice ? 'ion eye-outline' : 'ion eye-off-outline'
  }

  get isLegal() {
    return this.billing_info.type === BillingInfoType.LEGAL
  }

  get persianPersonTypes() {
    return {
      'legal': 'حقوقی',
      'natural': 'حقیقی'
    }
  }

}
